<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{
          edit
            ? `Edit Program Batch Term - ${form.term} Schedule`
            : `Add Program Batch Term - ${form.term} Schedule`
        }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="4">
            <v-menu
              v-model="showStartDatePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedStartDate"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="Start Date*"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.start_date"
                :min="minStartDate"
                @input="trackDateChange(), (showStartDatePicker = false)"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="4">
            <v-menu
              v-model="showEndDatePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedEndDate"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="End Date*"
                  outlined
                  dense
                  hide-details="auto"
                  :disabled="!form.start_date"
                  :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.end_date"
                :min="minEndDate"
                @input="showEndDatePicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">
          {{ edit ? "Update" : "Save" }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    termSchedule: {
      type: Object,
      default: () => ({}),
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules,
      form: {},
      showStartDatePicker: false,
      showEndDatePicker: false,
    };
  },
  computed: {
    minStartDate() {
      return this.currentDate(new Date());
    },
    minEndDate() {
      if (!this.form.start_date) return "";
      const d = new Date(this.form.start_date);
      d.setDate(d.getDate() + 1);
      return this.currentDate(d);
    },
    formattedStartDate() {
      if (!this.form.start_date) return "";
      const [year, month, day] = this.form.start_date.split("-");
      return `${day}-${month}-${year}`;
    },

    formattedEndDate() {
      if (!this.form.end_date) return "";
      const [year, month, day] = this.form.end_date.split("-");
      return `${day}-${month}-${year}`;
    },
  },
  watch: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      this.form = { ...this.termSchedule };
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.edit
        ? this.$emit("update", this.form)
        : this.$emit("create", this.form);
    },

    currentDate(date) {
      const d = new Date(date);
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    trackDateChange() {
      if (this.form.start_date >= this.form.end_date) {
        this.form.end_date = "";
      }
    },
  },
};
</script>
